// Cohort details data - separated to avoid babel plugin issues
export const cohortDetails = {
  1: {
    summary: 'This intensive 12-week program is designed to transform you into a skilled offensive security professional. Through hands-on labs, real-world projects, and expert mentorship, you will master penetration testing methodologies and red team operations.',
    topics: [
      'Network Penetration Testing',
      'Web Application Security Testing',
      'Active Directory Attacks',
      'Social Engineering',
      'Wireless Security',
      'Reporting & Documentation'
    ],
    suitableFor: [
      'IT professionals transitioning to security',
      'Junior penetration testers',
      'Security analysts wanting offensive skills',
      'Career changers with technical background'
    ],
    benefits: [
      'Industry-recognized certification',
      'Portfolio of real assessments',
      'Job placement assistance',
      '1:1 mentorship sessions',
      'Lifetime community access'
    ],
    curriculum: [
      'Weeks 1-3: Fundamentals & Reconnaissance',
      'Weeks 4-6: Network Exploitation',
      'Weeks 7-9: Web Application Security',
      'Weeks 10-11: Active Directory & Pivoting',
      'Week 12: Capstone Project & Career Prep'
    ],
  },
};
